import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getNombresOperarios`, method: 'GET', body: null, token: token})
}
